import * as config from '../config.js';
import { enum_value } from '../../util/enumtool.js';
import * as event_mod from '../event.js';
import { EventKind } from '../event.js';
import { init_datalayer, push_utag_data } from '../init.js';
import { PAGE_VARS } from '../../page/vars.js';
import { cache_handler } from '../util.js';

import $ from 'jquery';

// ===========================================================================
// Globals
// ===========================================================================

// Module name
export const MODULE_NAME = 'datalayer_gc';

// Re-exports
export let global_vars = {};

// Datalayer values
export const GIFT_CATALOGUE = {
    impression_id: [],
    impression_name: [],
    impression_category: [],
    impression_list_variant: [],
    impression_price: [],
    impression_list_name: [],
    impression_position: [],

    id: [],
    name: [],
    brand: [],
    variant: [],
    category: [],

    promo_id: [],
    promo_name: [],
    promo_creative: [],
    promo_position: [],
};

// ===========================================================================
// GC datalayer handlers
// ===========================================================================

function variant_handler(global, utag_data) {
    // inputchange is a jquery event setup in cache_handler() function
    $('#giftCatalogueSelectedVariantSku').on('inputchange', event => {
        let variant = event.currentTarget.getAttribute('value');
        utag_data['product_variant'] = [variant];
        event_mod.dispatch(global, EventKind.ProductDetail);
    });
}

// ===========================================================================
// Data layer
// ===========================================================================

function update_data(global, utag_data, url, title) {
    utag_data['page_type'] = enum_value(PAGE_VARS.kind);
    utag_data['page_name'] = title;
    utag_data['page_category_sbu'] = 'OGC';
    utag_data['impression_id'] = GIFT_CATALOGUE.impression_id;
    utag_data['impression_name'] = GIFT_CATALOGUE.impression_name;
    utag_data['impression_category'] = GIFT_CATALOGUE.impression_category;
    utag_data['impression_variant'] = GIFT_CATALOGUE.impression_list_variant;
    utag_data['impression_price'] = GIFT_CATALOGUE.impression_price;
    utag_data['impression_list'] = GIFT_CATALOGUE.impression_list_name;
    utag_data['impression_position'] = GIFT_CATALOGUE.impression_position;
    utag_data['product_id'] = GIFT_CATALOGUE.id;
    utag_data['product_name'] = GIFT_CATALOGUE.name;
    utag_data['product_brand'] = GIFT_CATALOGUE.brand;
    utag_data['product_variant'] = GIFT_CATALOGUE.variant;
    utag_data['product_category'] = GIFT_CATALOGUE.category;
    utag_data['promo_imp_ids'] = GIFT_CATALOGUE.promo_id;
    utag_data['promo_imp_names'] = GIFT_CATALOGUE.promo_name;
    utag_data['promo_imp_creatives'] = GIFT_CATALOGUE.promo_creative;
    utag_data['promo_imp_positions'] = GIFT_CATALOGUE.promo_position;

    utag_data['page_url'] = url;
    utag_data['device_type'] = config.DEVICE.device;
    utag_data['enh_action'] = PAGE_VARS.action;

    push_utag_data(utag_data);
}

function init_handlers(global, data) {
    // Setup data layer handlers
    cache_handler(global);
    variant_handler(global, data.utag_data);
}

// global is the window object when in the browser context this function should
export function initialize(global) {
    init_datalayer(global, init_handlers, update_data);
}

// ===========================================================================
//
// ===========================================================================
